import { createTheme } from '@mui/material/styles';

const baseThemeConfig = {
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none' },
        contained: { boxShadow: '0 2px 6px rgba(0,0,0,0.08)' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 8 } },
    },
  },
};

const getScrollBarStyles = (isDark) => ({
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: isDark ? '#000000' : '#f6f7f9',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
          background: isDark ? '#111111' : '#eceff3',
        },
        '&::-webkit-scrollbar-thumb': {
          background: isDark ? '#333333' : '#c5c9cf',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: isDark ? '#444444' : '#aeb4bc',
        },
      },
    },
  },
});

const getSurfaceTweaks = (isDark) => ({
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        border:
          isDark ? '1px solid rgba(255,255,255,0.06)' : '1px solid #e6e8eb',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        background: isDark
          ? 'linear-gradient(to right, #0c0c0c, #111111)'
          : 'linear-gradient(to right, #ffffff, #f3f9f5)',
        color: isDark ? '#ffffff' : '#0b0b0b',
        boxShadow: isDark
          ? '0 1px 0 rgba(255,255,255,0.06)'
          : '0 1px 0 rgba(0,0,0,0.06)',
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: isDark ? 'rgba(255,255,255,0.08)' : '#e6e8eb',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        '&.Mui-selected': {
          backgroundColor: isDark ? 'rgba(0,121,201,0.16)' : 'rgba(0,121,201,0.10)',
        },
      },
    },
  },
});

export const lightTheme = createTheme({
  ...baseThemeConfig,
  palette: {
    mode: 'light',
    primary: { main: '#0079C9', light: '#00FFFF', dark: '#0035CA' },
    secondary: { main: '#00FFFF' },
    background: { default: '#ffffff', paper: '#ffffff' },
    divider: '#e6e8eb',
    text: { primary: '#231F20', secondary: '#666666' },
  },
  shadows: [
    'none',
    '0 1px 3px rgba(0,0,0,0.06)',
    '0 2px 6px rgba(0,0,0,0.06)',
    '0 4px 10px rgba(0,0,0,0.08)',
    ...Array(21).fill('0 8px 24px rgba(0,0,0,0.10)'),
  ],
  components: {
    ...baseThemeConfig.components,
    ...getScrollBarStyles(false),
    ...getSurfaceTweaks(false),
  },
});

export const darkTheme = createTheme({
  ...baseThemeConfig,
  palette: {
    mode: 'dark',
    primary: { main: '#0079C9' },
    secondary: { main: '#00FFFF' },
    background: { default: '#000000', paper: '#111111' },
    divider: 'rgba(255,255,255,0.08)',
    text: { primary: '#ffffff', secondary: '#cccccc' },
  },
  components: {
    ...baseThemeConfig.components,
    ...getScrollBarStyles(true),
    ...getSurfaceTweaks(true),
  },
});

export const theme = lightTheme;
